import { createApp } from 'vue'
import warrantyPage from '@/pages/warranty/warranty.vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

createApp(warrantyPage).use(VueReCaptcha, { siteKey: window.af_reCaptchaSiteKey }).mount('#form');
